import React, { useState } from 'react'
import door from '../../assets/img/icon/door.png'
import download from '../../assets/img/icon/download.png'
import logo from '../../assets/img/carepay/ver_logo.png'
import vector from '../../assets/img/icon/Vector.png'

const ServiceModal = ({ selectedService, closeModal }) => {
  const [selectedIndex, setSelectedIndex] = useState(null)

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-end bg-black bg-opacity-50 mobile:w-full mobile:p-5'
      onClick={closeModal}
    >
      <button
        className='absolute top-[50px] right-[30px] '
        onClick={closeModal}
      >
        <img
          src='https://icons.veryicon.com/png/o/miscellaneous/all-blue-icon/close-428.png'
          alt='Arrow Down'
          className='h-6 w-6 mr-4'
        />
      </button>
      <div
        className='w-[462px] h-[100vh] bg-white px-6 py-2 flex flex-col shadow-xl mobile:w-full'
        onClick={e => e.stopPropagation()}
      >
        <div
          className='mt-4 flex flex-col justify-start items-start h-[100vh] overflow-y-auto p-4'
          style={{ scrollbarWidth: 'thin', scrollbarColor: ' #215998 #EBF4FF' }}
        >
          <p className='text-[18px] font-bold py-2'>{selectedService.title}</p>

          <img
            src={selectedService.photo}
            alt={selectedService.title}
            className='h-[315px] w-full object-cover rounded-lg'
          />
          <p className='text-[16px] text-justify py-2'>
            {selectedService.desc}
          </p>
          {selectedService.highlight1 && (
            <div className='bg-[#E9EFF6] p-4 flex flex-col justify-center items-center rounded-[16px]'>
              <h2 className='text-[16px] font-bold text-center'>
                {selectedService.highlight1.main}
              </h2>
              <p
                className='text-[12px] text-black/55 mt-2 text-center'
                style={{ lineHeight: 1.2 }}
              >
                {selectedService.highlight1.sub}
              </p>
            </div>
          )}
          {selectedService.highlight2 && (
            <div className='bg-[#E9EFF6] p-4 flex flex-col justify-center items-center rounded-[16px] mt-4'>
              <h2 className='text-[16px] font-bold text-center'>
                {selectedService.highlight2.main}
              </h2>
              <p
                className='text-[12px] text-black/55 mt-2 text-center'
                style={{ lineHeight: 1.2 }}
              >
                {selectedService.highlight2.sub}
              </p>
            </div>
          )}
          
          {selectedService.desc1 && (
            <p className='text-[16px] text-justify py-2'>
              {selectedService.desc1}
            </p>
          )}
          {selectedService.highlight3Top && (
            <p className='text-[16px] text-start py-2 font-bold'>
              {selectedService.highlight3Top}
            </p>
          )}
          {selectedService.desc2 && (
            <p className='text-[16px] text-start py-2'>
              {selectedService.desc2}
            </p>
          )}
          {selectedService.desc_1 && (
            <div className='bg-[#E9EFF6] p-4 flex text-center items-center rounded-[16px] w-full flex-col mt-4 mb-4'>
              <h2 className='text-[16px] font-bold '>
                {selectedService.desc_1}
              </h2>
            </div>
          )}
          {selectedService.text && (
            <h2 className='text-[16px] font-bold mt-0'>
              {selectedService.text}
            </h2>
          )}
          {selectedService.title1 && (
            <h2 className='text-[16px] font-bold mt-0'>
              {selectedService.title1}
            </h2>
          )}
          {selectedService.benefits && (
            <ul className='list-disc pl-5 mt-2'>
              {selectedService.benefits.map((benefit, index) => (
                <li key={index} className='mb-2 text-[12px] text-[#626578]'>
                  {benefit}
                </li>
              ))}
            </ul>
          )}
          {selectedService.benefitsSub && (
            <ul className='list-disc pl-5'>
              {selectedService.benefitsSub.map((benefit, index) => (
                <li key={index} className='mb-2 text-[12px] text-[#626578]'>
                  {benefit}
                </li>
              ))}
            </ul>
          )}
          {selectedService.highlight3 && (
            <>
              <p className='font-bold'> {selectedService.highlight3.main}</p>
              <ul className='pl-5 list-disc mt-2'>
                {selectedService.highlight3.sub.map((benefit, index) => (
                  <li
                    key={index}
                    className='mb-2 text-[12px] text-[#626578] ml-4'
                  >
                    {benefit}
                  </li>
                ))}
              </ul>
            </>
          )}
          {selectedService.highlight4 && (
            <>
              <p className='font-bold'> {selectedService.highlight4.main}</p>
              {selectedService.highlight4.desc && (
                <p className=''> {selectedService.highlight4.desc}</p>
              )}
              <ul className='pl-5 list-disc mt-2'>
                {selectedService.highlight4.sub.map((benefit, index) => (
                  <li
                    key={index}
                    className='mb-2 text-[12px] text-[#626578] ml-4'
                  >
                    {benefit}
                  </li>
                ))}
              </ul>
            </>
          )}
          {selectedService.highlight5 && (
            <>
              <p className='font-bold'> {selectedService.highlight5.main}</p>
              <ul className='pl-5 list-disc mt-2'>
                {selectedService.highlight5.sub.map((benefit, index) => (
                  <li
                    key={index}
                    className='mb-2 text-[12px] text-[#626578] ml-4'
                  >
                    {benefit}
                  </li>
                ))}
              </ul>
            </>
          )}
          {selectedService.highlight6 && (
            <>
              <p className='font-bold'> {selectedService.highlight6.main}</p>
              {selectedService.highlight6.desc.map((benefit, index) => (
                <li
                  key={index}
                  className='mb-2 text-[12px] text-[#626578] ml-4'
                >
                  {benefit}
                </li>
              ))}
            </>
          )}
          {selectedService.title3 && (
            <h2 className='text-[16px] font-bold mt-0'>
              {selectedService.title3}
            </h2>
          )}
          {selectedService.process && (
            <div className='flex flex-col '>
              {selectedService.process.map(item => (
                <div>
                  <p className='font-semibold mb-2'>{item.title}</p>
                  <ul className='list-disc pl-5'>
                    {item.desc.map((item, index) => (
                      <li key={index} className='mb-2 text-sm text-gray-700'>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}

          {selectedService.text2 && (
            <h2 className='text-[16px] font-normal mt-4'>
              {selectedService.text2}
            </h2>
          )}
          {selectedService.treatments && (
            <div className='bg-[#E9EFF6]  flex flex-col justify-center items-center rounded-[16px] mt-4 p-2 mb-4'>
              {selectedService.title2 && (
                <h2 className='text-[16px] font-bold'>
                  {selectedService.title2}
                </h2>
              )}
              {selectedService.treatments && (
                <ul className='pl-5 mt-2'>
                  {selectedService.treatments.map((treat, index) => (
                    <li key={index} className='mb-2 text-[12px] text-[#626578]'>
                      {treat}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
          {selectedService.after && selectedService.after.main && (
            <p className='font-bold'> {selectedService.after.main}</p>
          )}
          {selectedService.after && (
            <ul className='list-disc pl-5  mt-2'>
              {selectedService.after.sub.map((treat, index) => (
                <li key={index} className='mb-2 text-[1₮px] text-[#626578]'>
                  {treat}
                </li>
              ))}
            </ul>
          )}
          {selectedService.text4 && (
            <h2 className='text-[14px] font-normal text-center'>
              {selectedService.text4}
            </h2>
          )}
          {selectedService.title4 && (
            <div className='bg-[#E9EFF6] p-4 flex text-center items-center rounded-[16px] w-full flex-col mt-4'>
              <h2 className='text-[20px] font-bold '>
                {selectedService.title4}
              </h2>
              <p className='text-[18px]'>{selectedService.title4t}</p>
            </div>
          )}
          {!selectedService.priceBox && (
            <div
              className=' w-full border border-gray-200 rounded-xl text-black flex flex-row justify-between items-center p-5 gap-4 cursor-pointer mt-5'
              onClick={() => window.open('https://carepay.mn/')}
            >
              <div className='w-1/4'>
                <img src={logo} alt='carepaylogo'></img>
              </div>
              <div className='w-3/4 text-[14px] ml-2'>
                Та хүү, шимтгэлгүйгээр 3-12 хуваан төлөх боломжтой.
              </div>
            </div>
          )}
          {selectedService.priceBox && (
            <div className=' w-full border border-gray-200 rounded-xl text-[#215998] flex flex-row justify-between items-center p-5 gap-4 mt-5'>
              <div className='w-full text-[14px] ml-2 text-center'>
                {selectedService.priceBox}
              </div>
            </div>
          )}

          {selectedService.priceList && (
            <div className=' w-full border border-gray-200 rounded-xl p-4 mt-5'>
              <p className='mb-2 text-[18px]'>NIPT шинжилгээний сонголтууд</p>
              {selectedService.priceList.map((main, index) => (
                <div className='flex flex-col' key={index}>
                  <div
                    className='flex flex-row mt-2 mb-2 justify-between items-center cursor-pointer w-full'
                    onClick={() =>
                      setSelectedIndex(index === selectedIndex ? null : index)
                    }
                  >
                    <p
                      className={`text-[16px] font-inter-bold  ${
                        index === selectedIndex
                          ? 'font-inter-bold text-[16px]'
                          : ''
                      }`}
                    >
                      {main.name}
                    </p>
                    <div className='flex flex-row justify-end items-center'>
                      <p className='mr-2'>{main.price}</p>
                      <img
                        src={vector}
                        className={`w-2 h-full text-end ${
                          index === selectedIndex ? 'rotate-90' : ''
                        }`}
                        alt='icon'
                      />
                    </div>
                  </div>

                  {/* Render genList only for the selected item */}
                  {selectedIndex === index &&
                    selectedService.genList &&
                    selectedService.genList.map((second, idx) => (
                      <div key={idx} className='ml-2 '>
                        <p className='font-bold text-[14px]'>
                          Үнэ: {main.price.toLocaleString()}
                        </p>
                        {second.main && (
                          <p className='text-[14px] mb-2 mt-4'>{second.main}</p>
                        )}
                        {second.aList &&
                          second.aList.map((item, itemIdx) => (
                            <p key={itemIdx} className='text-[12px]'>
                              - {item}
                            </p>
                          ))}
                        {second.main1 &&
                          main.name !== '10 хромосомын эмгэг' && (
                            <p className='text-[14px] mb-2 mt-4'>
                              {second.main1}
                            </p>
                          )}
                        {second.bList &&
                          main.name !== '10 хромосомын эмгэг' &&
                          second.bList.map((item, itemIdx) => (
                            <p key={itemIdx} className='text-[12px]'>
                              - {item}
                            </p>
                          ))}
                        {second.main2 &&
                          main.name === '424 хромосомын эмгэг' && (
                            <p className='text-[14px] mb-2 mt-4'>
                              {second.main2}
                            </p>
                          )}
                        {second.cList &&
                          main.name === '424 хромосомын эмгэг' &&
                          second.cList.map((item, itemIdx) => (
                            <p key={itemIdx} className='text-[12px]'>
                              - {item}
                            </p>
                          ))}
                        {second.main3 &&
                          main.name === '424 хромосомын эмгэг' && (
                            <p className='text-[14px] mb-2 mt-4'>
                              {second.main3}
                            </p>
                          )}
                        {second.dList &&
                          main.name === '424 хромосомын эмгэг' &&
                          second.dList.map((item, itemIdx) => (
                            <p key={itemIdx} className='text-[12px]'>
                              - {item}
                            </p>
                          ))}
                        {second.main4 &&
                          main.name === '123 хромосомын эмгэг' && (
                            <p className='text-[14px] mb-2 mt-4'>
                              {second.main4}
                            </p>
                          )}
                        {second.eList &&
                          main.name === '123 хромосомын эмгэг' &&
                          second.eList.map((item, itemIdx) => (
                            <p key={itemIdx} className='text-[12px]'>
                              - {item}
                            </p>
                          ))}
                      </div>
                    ))}
                </div>
              ))}
            </div>
          )}
        </div>
        {selectedService.title5 && (
          <div className='bg-[#E9EFF6]  flex flex-col justify-center items-center rounded-[16px] mt-4 p-2 mb-4'>
            {selectedService.title5}
          </div>
        )}
        <div className=' w-full border border-gray-200  rounded-[16px] p-2 mt-4'>
          {selectedService.price && (
            <div className='flex flex-row justify-between py-2'>
              <p className='text-[16px]'>
                {selectedService.priceDesc ? 'Эхний хадгалалтын үнэ: ' : 'Үнэ:'}
              </p>
              <div className='flex flex-col justify-center items-end'>
                <p className='text-[18px] font-bold'>
                  {selectedService.price.toLocaleString()}₮
                </p>
                {/* {selectedService.priceDesc && (
                <p className='text-[10px]'>({selectedService.priceDesc})</p>
              )} */}
              </div>
            </div>
          )}
          <div className='flex flex-row justify-between items-center w-full gap-2 text-[12px]'>
            {selectedService.isBrochure && (
              <button
                className='flex h-[48px] min-w-[64px] px-4 justify-center items-center gap-0 rounded-lg border border-[#215998] bg-[white] text-[#215998] w-full '
                onClick={() => window.open(`${selectedService.pdfUrl}`)}
              >
                <img
                  src={download}
                  alt='Arrow Down'
                  className='h-4 w-4'
                  style={{ marginRight: 10 }}
                />
                Танилцуулга татах
              </button>
            )}
            <button className='flex h-12 min-w-[84px] w-full px-4 justify-center items-center gap-0 rounded-lg border border-[rgba(255,255,255,0.16)]  bg-[#215998] text-white '>
              <img
                src={door}
                alt='Arrow Down'
                className='h-4 w-4'
                style={{ marginRight: 10 }}
              />
              Цаг захиалах
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServiceModal
